<template>
  <!-- 活动规则 -->
  <div class="Dialog rule" v-if="isRulesShown">
    <div class="inner">
      <div class="pic-bg"></div>
      <div class="pic-birld"></div>
      <div class="pic-cloud"></div>

      <div class="icon-close" @click="send('CLOSE_RULE')"></div>
      <div class="title"><span>活动规则</span></div>

      <div class="inner-body">
        <p class="content" style="font-size: 14px;" v-html="state.context.gameConfig.rules"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api"
export default {
  name: "Rule",
  props: ["state", "send"],
  setup(props) {
    const isRulesShown = computed(() => {
      return ["rules"].some(props.state.matches)
    })
    return {
      isRulesShown
    }
  }
}
</script>

<style scoped>
</style>
